import React from 'react'
import EmailUsageReport from './EmailUsageReport'
import { fetchEmailUsageReport } from '../../api'
import moment from 'moment'
import { DateTime } from 'luxon'
import { toISOString, getUserTimezone } from '../../utils/dateUtils'

export default class EmailUsageReportContainer extends React.Component {
  state = {
    filterBy: 'month',
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
    day: new Date().getDate(),
    isLoading: false,
    reportData: null,
    error: null,
  }

  // Create date range based on filter type, considering user's selected timezone
  // Using Luxon for proper timezone handling
  createDateRange = function () {
    const userTimezone = getUserTimezone()
    let startDt, endDt

    if (this.state.filterBy === 'year') {
      // Entire year - from Jan 1 00:00:00 to Dec 31 23:59:59 in user's timezone
      startDt = DateTime.fromObject(
        { year: this.state.year, month: 1, day: 1 },
        { zone: userTimezone }
      ).startOf('day')

      endDt = DateTime.fromObject(
        { year: this.state.year, month: 12, day: 31 },
        { zone: userTimezone }
      ).endOf('day')
    } else if (this.state.filterBy === 'month') {
      // Entire month - from first day 00:00:00 to last day 23:59:59 in user's timezone
      startDt = DateTime.fromObject(
        { year: this.state.year, month: this.state.month + 1, day: 1 },
        { zone: userTimezone }
      ).startOf('day')

      endDt = DateTime.fromObject(
        { year: this.state.year, month: this.state.month + 1 },
        { zone: userTimezone }
      )
        .endOf('month')
        .endOf('day')
    } else if (this.state.filterBy === 'day') {
      // Single day - from 00:00:00 to 23:59:59 in user's timezone
      startDt = DateTime.fromObject(
        { year: this.state.year, month: this.state.month + 1, day: this.state.day },
        { zone: userTimezone }
      ).startOf('day')

      endDt = DateTime.fromObject(
        { year: this.state.year, month: this.state.month + 1, day: this.state.day },
        { zone: userTimezone }
      ).endOf('day')
    }

    // Return DateTime objects (will be converted to ISO by toISOString)
    return {
      startDate: startDt.toJSDate(),
      endDate: endDt.toJSDate(),
    }
  }

  handleFilterChange = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value,
    })
  }

  fetchReportData = async () => {
    this.setState({ isLoading: true, error: null })

    try {
      const { startDate, endDate } = this.createDateRange()
      const params = {
        startDate: toISOString(startDate),
        endDate: toISOString(endDate),
      }

      const data = await fetchEmailUsageReport(params)
      this.setState({ reportData: data, isLoading: false })
    } catch (error) {
      console.error('Error fetching email usage report:', error)
      this.setState({ error: error.message, isLoading: false })
    }
  }

  componentDidMount() {
    // Automatically fetch report data on mount
    this.fetchReportData()
  }

  componentDidUpdate(prevProps, prevState) {
    // Re-fetch data when filter changes
    if (
      prevState.filterBy !== this.state.filterBy ||
      prevState.year !== this.state.year ||
      prevState.month !== this.state.month ||
      prevState.day !== this.state.day
    ) {
      this.fetchReportData()
    }
  }

  render() {
    return (
      <EmailUsageReport
        onFilterChange={this.handleFilterChange}
        filter={this.state}
        reportData={this.state.reportData}
        error={this.state.error}
        isLoading={this.state.isLoading}
      />
    )
  }
}
